var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarSmall = function SvgStarSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 6 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00CCBC",
    d: "m6 3.785-2.647.201-.201 2.647-.201-2.647-2.647-.201 2.647-.202.2-2.646.202 2.646z"
  })));
};
export { SvgStarSmall as ReactComponent };
export default __webpack_public_path__ + "fonts/star-small-9ca6f30e94239c049e111ad338d0b89c.svg";